// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"e_Rg","content":"e_Sg","container":"e_Tg"};